import { CustomerPortalApi } from "breuer-supercharged-sdk";
import type {
  ConfirmBestellungDto,
  RespondToOfferDto,
} from "breuer-supercharged-sdk";
import type { CustomerSettableAttachmentStatus } from "shared-lib";
import { getClient } from "./client";

export class CustomerPortalRepository {
    private static instance: CustomerPortalRepository;
    private constructor() { }
    public static getInstance(): CustomerPortalRepository {
        if (!CustomerPortalRepository.instance) {
            CustomerPortalRepository.instance = new CustomerPortalRepository();
        }
        return CustomerPortalRepository.instance;
    }

    private client = new CustomerPortalApi(undefined, undefined, getClient());

    public async getAccount() {
        const res = (await this.client.getCustomerAccount()).data;
        return res;
    }

    public async getConstructionSiteContainers() {
        const res = (await this.client.getConstructionSiteContainers()).data;
        return res;
    }

    public async getRelevantTenantsForAccount() {
        const res = (await this.client.getRelevantTenantsForAccount()).data;
        return res;
    }

    public async getConstructionSiteContainerById(id: string) {
        const res = (await this.client.cgetConstructionSiteContainerById(id)).data;
        return res;
    }

    public async uploadAttachment(
        containerId: string,
        name: string,
        file: File
    ) {
        const res = (
            await this.client.cuploadConstructionSiteContainerAttachment(
                containerId,
                name,
                file
            )
        ).data;
        return res;
    }

    /** One request for any number of files, all-or-nothing; customers may only set nicht_freigegeben/freigegeben (#218). */
    public async updateAttachmentStatus(
        containerId: string,
        attachmentIds: string[],
        status: CustomerSettableAttachmentStatus
    ) {
        const res = (
            await this.client.cupdateConstructionSiteContainerAttachmentStatus(
                containerId,
                { attachmentIds, status }
            )
        ).data;
        return res;
    }

    public async respondToOffer(
        containerId: string,
        offerId: string,
        dto: RespondToOfferDto
    ) {
        await this.client.respondToOffer(containerId, offerId, dto);
    }

    /**
     * Bestellung detail for the customer-portal flow.
     * Auth: account JWT (customer must own the container) OR one-time-token
     * JWT (`bestellungId` claim must equal `:id`). The backend enforces both.
     */
    public async getBestellung(id: string) {
        const res = (await this.client.getCustomerPortalBestellung(id)).data;
        return res;
    }

    /**
     * Single-click confirmation OR pick a Vorschlag.
     * If `lieferdatumVorschlaege` is non-empty `chosenLieferdatum` MUST be
     * one of them (server-side validated, returns 400 otherwise).
     */
    public async confirmBestellung(id: string, dto: ConfirmBestellungDto) {
        const res = (await this.client.confirmCustomerPortalBestellung(id, dto)).data;
        return res;
    }

    /** Reject all proposals — backend flips status back to `eingegangen`. */
    public async rejectBestellung(id: string) {
        const res = (await this.client.rejectCustomerPortalBestellung(id)).data;
        return res;
    }
}